import React, { FC, useCallback } from "react";
import {
  PentrackerUser,
  UserWrapper,
} from "../../../../../../domain/user/User";
import { FixedSizeList as List } from "react-window";
import { AutoSizer, Size } from "react-virtualized";
import { UserSearchRow } from "./row";
import { EmptyState } from "../../../../../components/state/empty";
import { faList, faSearch } from "@fortawesome/free-solid-svg-icons";

export type UserSearchListProps = {
  items: PentrackerUser[] | null;
  onClick: (user: PentrackerUser) => void;
  appUser?: UserWrapper;
};

export type UserSearchListRowProps = {
  items: PentrackerUser[];
  onClick: React.MouseEventHandler<HTMLDivElement>;
};

export const UserSearchListWindow: FC<UserSearchListProps> = ({
  items,
  onClick,
  appUser,
}) => {
  /* eslint-disable */
  const onRowClick = useCallback<React.MouseEventHandler<HTMLDivElement>>(
    (e) => {
      if (!items) return;
      const index = e.currentTarget.dataset.index;
      if (index) {
        onClick(items[index as unknown as number]);
      }
    },
    [items]
  );

  /* eslint-enable */

  return items === null ? (
    <EmptyState
      icon={faSearch}
      title={
        appUser?.isClient() || appUser?.isSupervisor()
          ? "Buscar Personal"
          : "Buscar Usuario"
      }
      message={"Ingrese un término de búsqueda."}
    />
  ) : items.length > 0 ? (
    //@ts-ignore
    <AutoSizer>
      {(props: Size) => (
        <List
          height={props.height}
          itemCount={items?.length || 0}
          itemSize={200}
          width={props.width}
          itemData={{
            items,
            onClick: onRowClick,
          }}
        >
          {UserSearchRow}
        </List>
      )}
    </AutoSizer>
  ) : (
    <EmptyState
      icon={faList}
      title={"Sin resultados"}
      message={`No hay tickets que coincidan con la búsqueda.`}
    />
  );
};
